import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LabelSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LabelSVG;
